import '.f0{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.f1{padding-left:1.5rem;}.ssr-plugin'
import '.f2{margin:1rem 0;}.ssr-plugin'
import '.f3{color:var(--gray-700);}.ssr-plugin'
import '.f4{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="f0 f1 f2 f3 f4"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
